/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.controllers {
    export interface ITestAutoVersionAndActivateScope extends angular.IScope {
        model: any;
        versionAndActivate: () => void;
        processConfigSelectionChanged: (processConfig: any) => void;
        allowVersionAndActivation: boolean;
    }

    export class TestAutoVersionAndActivateController implements IController {
        constructor(
            private $scope: ITestAutoVersionAndActivateScope,
            private testService: services.TestService)
        {
            $scope.allowVersionAndActivation = true;

            $scope.model = {
                processConfigs: [],
                processConfigIds: [],
                versionName: ''
        }
            testService.getInWorkProcessConfigs().then((processConfigs) => {
                $scope.model.processConfigs = processConfigs;
            });

            $scope.versionAndActivate = () => this.versionAndActivate();
            $scope.processConfigSelectionChanged = (processConfig: any) => this.processConfigSelectionChanged(processConfig);
        }

        private versionAndActivate() : void {
            this.testService.batchVersionAndActivate(this.$scope.model).then(() => {
                alert("Batch Version and Activation has been kicked off.");
                this.$scope.allowVersionAndActivation = false;
            });
        }

        private processConfigSelectionChanged(processConfig: any) {
            if (processConfig.selected) {
                this.$scope.model.processConfigIds.push(processConfig.processConfigId);
            } else {
                this.$scope.model.processConfigIds = Enumerable.from(this.$scope.model.processConfigIds)
                    .where(i => i !== processConfig.processConfigId)
                    .toArray();
            }
        }
    }
}

warsApp.registerController("TestAutoVersionAndActivateController", ["$scope", "testService"]);